/**
 * window.BIC {
 *   endpoint_data: {
 *     node_endpoint: '',
 *     wp_host: '',
 *     wp_rest_endpoint: ''
 *   }
 * }
 */

export default function getHostEndpoint(endpoint) {
  if (window && window.BIC && window.BIC.endpoints && window.BIC.endpoints[endpoint]) {
    return window.BIC.endpoints[endpoint]
  }

  /**
   * @TODO: make default endpoints map to return what is set in the .env file
   */

  return null
}
